import './index.css'
import ReactDOM from 'react-dom/client'
import App from './App'
import {
  BrowserRouter,
} from 'react-router'
import { Provider } from 'react-redux'
import { createStore } from './redux/store.tsx'
import * as Sentry from '@sentry/react'


const preloadedState = (window as any).__PRELOADED_STATE__
delete (window as any).__PRELOADED_STATE__

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_URL,
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ['www.kbw.de/inhouse', 'dev.kbw.de/inhouse'],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
})

const store = createStore(preloadedState)

ReactDOM.hydrateRoot(
  document.getElementById('root') as HTMLElement,
  <BrowserRouter basename={'/inhouse'}>
    <Provider store={store}>
      <App />
    </Provider>
  </BrowserRouter>,
)
